// Module
var code = "<toolbar-color-menu colors=\"parent.elementColors\" menu-type=\"textBorder\" on-select=\"parent.updateTextboxBorderColor(color)\" transparent-button-text=\"No Border\"> </toolbar-color-menu> ";
// Exports
module.exports = code;